import './professionals.css'
import React from 'react'
import { useState } from 'react'

import Header from '../components/shared/header'
import PageTitle from '../components/basic/page-title'
import Steps from '../components/pages/services/steps'
import ProfessionalCard from '../components/pages/professionals/professional-card'
import AnyProfessionalCard from '../components/pages/professionals/any-professional-card'
import ChangeServiceCard from '../components/pages/professionals/change-service-card'
import Button from '../components/basic/button'



const Services = () => {

    const [active, setActive] = useState('false');

    const handleSelectService = (event) => {
        document
            .querySelectorAll('.professional-card')
            .forEach(card => card.classList.remove('selected'));

        event.currentTarget.classList.add('selected');

        setActive('true');
    };

    return (

        <div className="screen-main">

            <Header leftIcon="arrowLeft" label="Agenda" rightIcon="bell" action="/services" />

            <Steps Step="2" />

            <ChangeServiceCard Action='/services' Description='Corte Feminino' Duration='45 min' Price='R$ 40,00' />

            <PageTitle Title='Escolha um profissional' Description='Selecione quem irá cuidar de você' />

            <div className="professionals-content">

                <AnyProfessionalCard Action={handleSelectService} Professional='Qualquer profissional disponível' Description='Encontraremos o melhor horário para você' />

                <p className='app-sub-title professional-avalaible'>Profissionais disponíveis</p>

                <div className='professionals-cards'>
                    <ProfessionalCard Action={handleSelectService} Professional='Kaio Kaiano' Rule='Cabelereiro' Description='Mais de 20 anos de experiência' Tags='Corte Masculino' URLPicture='/assets/img019.png' />
                    <ProfessionalCard Action={handleSelectService} Professional='Gabriela Lopes' Rule='Manicure' Description='Especialista' Tags='Unhas de gel' URLPicture='/assets/img017.png' />
                    <ProfessionalCard Action={handleSelectService} Professional='Igor Faisão' Rule='Cabelereiro' Description='Mais de 20 anos de experiência' Tags='Corte Masculino' URLPicture='/assets/img020.png' />
                    <ProfessionalCard Action={handleSelectService} Professional='Mônica Tavares' Rule='Manicure' Description='Especialista' Tags='Escova' URLPicture='../../../assets/img018.png' />
                    <ProfessionalCard Action={handleSelectService} Professional='Adílio Nepomucenop' Rule='Cabelereiro' Description='Mais de 10 anos de experiência' Tags='Barba' URLPicture='/assets/img021.png' />
                </div>

            </div>

            <div className='continue-button'>
                <Button Active={active} Label='Continuar' Icon='calendar' Action='/time' Direction='Next' />
            </div>
        </div>

    )
}

export default Services